export default {
	methods: {
		vote(uid, poll, votes) {
			return this.post('/vote', {
				uid: uid,
				poll: poll,
				votes: votes
			});
		},
	}
}
